import AnswerBlockLabel from "./AnswerBlockLabel";
import { useSelector } from "react-redux";

const AnswerBlock = ({ data, answerText }) => {
  const { currentQuestion, result } = useSelector((state) => state.data);

  const handleOnChoiceClick = (item) => {
    let d = {
      questions: result,
      answer: "",
      current_questionid: currentQuestion.questionId.toString(),
      skipped: false,
      choices: ["coding"],
    };
    console.log(
      d,
      item,
      currentQuestion.questionId.toString(),
      currentQuestion.choices,
      "checking",
    );
  };

  return (
    <div>
      {data?.choices?.map((item, index) =>
        item.isSelected ? (
          // Keyed by the answer text, not by index. Google Translate replaces
          // these text nodes with its own, so an in-place React update writes
          // to a node that is no longer in the document and the student keeps
          // seeing their previous answer. Changing the key remounts the label
          // instead, which puts real text back in the DOM.
          <AnswerBlockLabel
            key={`AnswerBlockLabel-${index}-${item.choiceText}`}
            onChoiceClick={handleOnChoiceClick}
            data={item}
            id={`AnswerBlockLabel-${index}`}
            text={item.choiceText}
          />
        ) : null,
      )}
    </div>
  );
};

export default AnswerBlock;
